import GridLayout from '../GridLayout';
import createWindowedLayout from '../createWindowedLayout';
import { getGridDataFromProps } from '../../shared';

/**
 * each section can have its own itemHeight but itemWidth is consistent
 * not supporting recursive structure - each section can have one level of top and bottom sections
 * each section can have 0,1 or multiple top and bottom sections
 */
const WindowedGridLayout = createWindowedLayout({
  getLayoutDataProps: getGridDataFromProps,
})(GridLayout);

export default WindowedGridLayout;
